import TypeStrictData, { fieldType } from '@/classes/common/TypeStrictData';

/**
 * 単元情報クラス
 */
export default class SectionData extends TypeStrictData {

  /** 単元No */
  @fieldType()
  public sectionNo: number = -1;

  /** 単元名 */
  @fieldType()
  public sectionName: string = '';

  /** ユニット数 */
  @fieldType()
  public unitCount: number = -1;

  /** 作者 */
  @fieldType()
  public author: string = '';

  /** カテゴリ */
  @fieldType()
  public category: string = '';



}
